import React from "react";
import "../../styles/global-hero.css";

const Hero = () => {
    return (
        <div className="global-hero">
            <div className="container text-center">
                <h1>Proceedings</h1>
                <p>Home &gt; Proceedings</p>
            </div>
        </div>
    );
};

export default Hero;
